@for (description of descriptions; track description) {
	@if (description | isNotEmpty: ['title', 'date']) {
		<span class="c-timeline__description__step-indicator"></span>
		<div>
			@if (description.title) {
				<strong>{{ description.title }}</strong>
			}
			@if (description.date) {
				<p class="c-vloket-text--s">{{ description.date | date: 'd MMMM y' }}</p>
			}
			@if (description.content) {
				<p class="c-vloket-text--s u-margin-bottom">{{ description.content }}</p>
			}
			<div class="c-timeline__description__alert">
				@if (description?.alert) {
					<cjm-alert
						[alertTitle]="
							isCondensed
								? (i18nKeys.SharedAssociations.Timeline.ActionRequiredLabel | translate)
								: description.alert
						"
						[isClosable]="false"
						[alertType]="'is-warning'"
					/>
				}
			</div>
			@if (links?.length && isCurrent) {
				<p>
					@for (link of links; track link) {
						<cjm-link
							[attr.aria-hidden]="true"
							[classes]="buttonClasses.LinkButton"
							[to]="link.url"
							[title]="link.text"
							[type]="link.type"
							[icon]="link.icon"
							>{{ link.text }}</cjm-link
						>
					}
				</p>
			}
		</div>
	}
}
